import { GoogleMeetIcon, MicrosoftTeamsIcon, OtherPlatformIcon, ZoomIcon } from "./assets";

export const DEFAULT_PLATFORM = { label: "Other", value: "other", icon: <OtherPlatformIcon /> } as const;

export const PLATFORM_OPTIONS = [
	{ label: "Google Meet", value: "googleMeet", icon: <GoogleMeetIcon /> },
	{ label: "Zoom", value: "zoom", icon: <ZoomIcon /> },
	{ label: "Microsoft Teams", value: "teams", icon: <MicrosoftTeamsIcon /> },
	DEFAULT_PLATFORM,
] as const;

const ONE_MINUTE = 60 * 1000;

export const DURATION_OPTIONS = [
	{ label: "30 minutes", value: 30 * ONE_MINUTE },
	{ label: "45 minutes", value: 45 * ONE_MINUTE },
	{ label: "1 hour", value: 60 * ONE_MINUTE },
	{ label: "1.5 hours", value: 90 * ONE_MINUTE },
	{ label: "2 hours", value: 120 * ONE_MINUTE },
] as const;
